import { Component, Input, EventEmitter, Output } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { BillingPaymentsProvider } from '../../providers/billing-payments/billing-payments';
import { ToastProvider } from '../../providers/toast/toast';
import { UtilService } from '../../services/util';
import { LoginProvider } from '../../providers/login/login';
import { MakePaymentPage } from '../make-payment/make-payment';
import { TranslateService } from '@ngx-translate/core';

@IonicPage()
@Component({
  selector: 'page-account-summary',
  templateUrl: 'account-summary.html',
})

export class AccountSummaryPage {
  
  billTypes = [];
	accountStatementData = [];
	pageNo = 1;
  showData = false;
  permissions: any;
  outstandings = [];
  selectedBillType: string;
  selRegistrationLogin : any ;
  @Output() onBillTypeSelect: EventEmitter<any> = new EventEmitter<any>();

  constructor(public navCtrl: NavController, 
    public navParams: NavParams, 
    public bpProvider: BillingPaymentsProvider,
    private toast: ToastProvider,
    private util: UtilService,
    private login: LoginProvider,
    private translate: TranslateService) {


      this.selRegistrationLogin = localStorage.getItem('signup_login')

      if(this.selRegistrationLogin){
this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.") 
this.showData = true
      }
      else{
  	bpProvider.getOutstandings(1).then(val => {
      this.outstandings = val.data;
      this.billTypes=[];
      this.billTypes =val.data;
      this.selectedBillType = this.billTypes[0].id;
      this.onBillTypeSelect.emit(this.selectedBillType);
      this.bpProvider.getAccountStatement(this.billTypes[0].id, this.pageNo).then(val => {
        if(val.status == "success"){
          this.accountStatementData = val.data;
        }else {
          this.accountStatementData = [];
        }
        this.showData = true;
      }).catch(val => {
        this.showData = true;
      });
    });
    
    login.getUserDetails().then(val => {
      this.permissions = val.permissions;
    });

  }
  }

  openUrl(url:string){
    this.util.openWithInAppBrowser(url);
  }

  onChange(id: string){
    this.showData = false;
    this.accountStatementData = [];
    this.selectedBillType = id;
    this.onBillTypeSelect.emit(this.selectedBillType);
  	this.bpProvider.getAccountStatement(id, this.pageNo).then(val => {
      if(val.status == "success"){
        this.accountStatementData = val.data;
      }else {
        this.accountStatementData = [];
      }
      this.showData = true;
  	}).catch(error => {
      this.accountStatementData  = [];
      this.showData = true;
    });
  }

  getIcon(item){
    if(item.type == "bill"){
      return {
        name: "paper",
        color: "danger"
      }
    }else if(item.type_of_payment == "DEBIT"){
      return {
        name: "card",
        color: "danger"
      }
    }else{
      return {
        name: "card",
        color: "success"
      }
    }
  }

  onPay(){
    if(this.selRegistrationLogin){
      console.log("hello true")
      this.toast.presentToast("You are Unauthorized to use this feature , Please request to admin.") 
            }else{
              console.log("hello false")
    this.navCtrl.push(MakePaymentPage, {
      billType: this.selectedBillType,
      outstanding: this.outstandings
    });
  }
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AccountSummaryPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/account-summary/account-summary.ts